import { Tooltip, TooltipProps, Typography, TypographyProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FC, ReactNode } from 'react';

const BaseEllipsisText = styled(Typography)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 200,
});

interface EllipsisTextProps extends TypographyProps {
    tooltip?: TooltipProps['title'];
    children: ReactNode;
    slotProps?: {
        tooltip?: TooltipProps;
    };
}

const EllipsisText: FC<EllipsisTextProps> = ({ children, tooltip, slotProps = {}, ...props }) => {
    return (
        <Tooltip title={tooltip} {...slotProps?.tooltip}>
            <BaseEllipsisText {...props}>{children}</BaseEllipsisText>
        </Tooltip>
    );
};

export default EllipsisText;
